import moment from 'moment';
import 'moment-timezone';

const timeZone = 'America/Sao_Paulo';
// eslint-disable-next-line consistent-return
export default function (value) {
  if (value) {
    return moment(value).tz(timeZone).format('DD/MM/YYYY HH:mm');
  }
}
